import styled from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

export const RangesText = styled(Text)`
  margin: 0;
  color: ${props => props.theme.colors.text.default};
  min-width: 50px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
